<!-- Comunicado Selecionado -->
<div class="comunicado-viewer" *ngIf="comunicado">
  <!-- Comunicado Header -->
  <div class="comunicado-viewer-header">
    <div class="header-content">
      <!-- Avatar -->
      <div class="header-avatar mr-2">
        <div class="sender-avatar-large">
          <i class="fas fa-user"></i>
        </div>
      </div>
      
      <!-- Sender Details -->
      <div class="header-sender">
        <div class="sender-info">
          <div class="sender-name">{{comunicado.remetente.nome}}</div>
          <!-- Email do remetente não será incluído nesta versão -->
          <!-- <div class="sender-email" *ngIf="comunicado.remetente.email">{{comunicado.remetente.email}}</div> -->
        </div>
      </div>
      
      <!-- Comunicado Date -->
      <div class="header-date">
        <div class="comunicado-date" [title]="formatDate(comunicado.enviado) | date: 'dd/MM/yy HH:mm'">
          <i class="fas fa-clock"></i>
          {{ formatDate(comunicado.enviado) | date: formatoDataCompleto : '' : localeAtual }}
        </div>
      </div>
      
      <!-- Botão Marcar como não lido -->
      <!-- 
        Nota: Os botões estão duplicados (um para cada estado) porque a atualização dinâmica 
        de ícones do FontAwesome está quebrada nesta versão. Renderizar elementos completos 
        condicionalmente com *ngIf garante que o ícone seja recriado do zero a cada mudança.
      -->
      <div class="header-actions">
        <button *ngIf="comunicado.lido" class="btn btn-outline-secondary btn-sm" (click)="onMarcarComoNaoLido()" [title]="'comunicado.lista.marcarComoNaoLido' | translate">
          <i class="fas fa-eye" style="margin-right: 0.5rem;"></i>
          <span translate>{{ 'comunicado.lista.marcarComoNaoLido' }}</span>
        </button>
        <button *ngIf="!comunicado.lido" class="btn btn-outline-secondary btn-sm" disabled [title]="'comunicado.lista.marcarComoLido' | translate">
          <i class="fas fa-eye-slash" style="margin-right: 0.5rem;"></i>
          <span translate>{{ 'comunicado.lista.marcarComoLido' }}</span>
        </button>
      </div>
    </div>
    
    <!-- Destinatários -->
    <div class="recipients-info" *ngIf="comunicado.destinatarios && comunicado.destinatarios.length > 0">
      <div class="p-grid p-nogutter">
        <div class="p-col-12 p-md-12 p-lg-12">
          <div class="recipients-container">
            <div class="recipients-label">
              <div class="align-middle">
                <i class="fas fa-users mr-1"></i>
              </div>
              <span>{{ 'comunicado.exibir.destinatarios' | translate }}:</span>
            </div>
            <div class="recipients-list">
            <span *ngFor="let destinatario of getDestinatariosParaExibir(); let last = last; let i = index" 
                  class="recipient-item">
              {{destinatario.nome}}<span *ngIf="!last">; </span>
            </span>
            
            <!-- 
              Nota: Os spans estão duplicados (um para cada estado) porque a atualização dinâmica 
              de ícones do FontAwesome está quebrada nesta versão. Renderizar elementos completos 
              condicionalmente com *ngIf garante que o ícone seja recriado do zero a cada mudança.
            -->
            <span *ngIf="temMaisDestinatarios()" class="recipients-more">
              <span *ngIf="!mostrarTodosDestinatarios" class="recipients-more-text" (click)="toggleMostrarTodos()">
                <i class="fas fa-chevron-down"></i>
                {{getTextoBotaoDestinatarios()}}
              </span>
              <span *ngIf="mostrarTodosDestinatarios" class="recipients-more-text" (click)="toggleMostrarTodos()">
                <i class="fas fa-chevron-up"></i>
                {{getTextoBotaoDestinatarios()}}
              </span>
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="comunicado-content-container">
    <!-- Comunicado Subject -->
    <div class="comunicado-subject-section">
      <div class="p-grid p-nogutter">
        <div class="p-col-12">
          <h1 class="comunicado-subject-title">{{comunicado.assunto}}</h1>
        </div>
      </div>
    </div>

    <!-- Comunicado Content -->
    <div class="comunicado-content-section">
      <div class="p-grid p-nogutter">
        <div class="p-col-12">
          <div class="comunicado-body">
            <div class="comunicado-text" [innerHTML]="comunicado.conteudo"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Attachments -->
    <div class="comunicado-attachments" *ngIf="comunicado.anexos && comunicado.anexos.length > 0">
      <div class="p-grid p-nogutter">
        <div class="p-col-12">
          <div class="attachments-header">
            <h3 class="attachments-title">
              <i class="fas fa-paperclip"></i>
              {{ 'comunicado.exibir.anexos' | translate }} ({{comunicado.anexos.length}})
            </h3>
          </div>
        </div>
      </div>
      
      <div class="p-grid">
        <div class="p-col-12 p-md-6 p-lg-6" *ngFor="let anexo of comunicado.anexos">
          <div class="attachment-item">
            <div class="attachment-content">
              <div class="attachment-left">
                <div class="attachment-icon" [ngClass]="getAttachmentClass(anexo.tipo)">
                  <i [ngClass]="getAttachmentIcon(anexo.tipo)"></i>
                </div>
                <div class="attachment-info">
                  <div class="attachment-name" [title]="anexo.nome">{{anexo.nome}}</div>
                  <div class="attachment-type">{{anexo.tipo.toUpperCase()}}</div>
                </div>
              </div>
              
              <div class="attachment-actions">
                <button class="btn-download" (click)="download(anexo.id)">
                  <i class="fas fa-download"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Loading State - Comunicado sendo carregado -->
<div class="loading-state" *ngIf="carregando">
  <div class="loading-content">
    <div class="loading-spinner">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <div class="loading-title" translate>{{ 'comunicado.exibir.carregandoComunicado' }}</div>
    <div class="loading-subtitle" translate>{{ 'comunicado.exibir.aguardeDetalhes' }}</div>
  </div>
</div>

<!-- Estado Vazio - Nenhum Comunicado Selecionado -->
<div class="empty-state" *ngIf="!comunicado && !carregando">
  <div class="empty-content">
    <div class="empty-icon">
      <i class="fas fa-envelope-open"></i>
    </div>
    <div class="empty-title" translate>{{ 'comunicado.exibir.nenhumComunicadoSelecionado' }}</div>
    <div class="empty-subtitle" translate>{{ 'comunicado.exibir.selecioneComunicadoLista' }}</div>
    <div class="empty-actions">
      <div class="empty-tip">
        <i class="fas fa-lightbulb"></i>
        <span translate>{{ 'comunicado.exibir.dicaCliqueComunicado' }}</span>
      </div>
    </div>
  </div>
</div>
